<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>EXAMINATION SCHEDULE</h2>
        </div>
    </div>
    <div class="shape9"><img src="assets/img/shape8.svg" alt="image"></div>
</div>

<div class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="about-text-container">
                    <h4 style="background: #29176d;color: white;padding: 21px; margin-bottom:15px">Back Paper Date
                        Sheet </h4>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/BACK%20PAPER%20FIRST%20SEMESTOR%20EXAMINATION%20DATE%20SHEET.pdf">BACK
                        PAPER FIRST SEMESTER EXAMINATION DATE SHEET</a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/BACK%20PAPER%20SECOND%20SEMESTOR%20EXAMINATION%20DATE%20SHEET.pdf">BACK
                        PAPER SECOND SEMESTER EXAMINATION DATE SHEET</a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/BACK%20PAPER%20THIRD%20SEMESTOR%20EXAMINATION%20DATE%20SHEET.pdf">BACK
                        PAPER THIRD SEMESTER EXAMINATION DATE SHEET</a></p>
                    <h4 style="background: #29176d;color: white;padding: 21px; margin-bottom:15px">Practical Date
                        Sheet </h4>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/PRACTICAL%20DATE%20SHEET%20OF%20ACADEMIC%20BATCH%20(A-2020-21).pdf"
                        class="examsc_a">PRACTICAL DATE SHEET OF ACADEMIC BATCH (A-2020-21)</a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/PRACTICAL DATE SHEET OF ACADEMIC BATCH (A-2021-22) (1).pdf"
                        class="examsc_a">PRACTICAL DATE SHEET OF ACADEMIC BATCH (A-2021-22)</a></p>

                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/PRACTICAL%20DATE%20SHEET%20OF%20CALENDAR%20BATCH%202020.pdf"
                        class="examsc_a">PRACTICAL DATE SHEET OF CALENDER BATCH 2020</a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/PRACTICAL%20DATE%20SHEET%20OF%20CALENDAR%20BATCH%202021.pdf"
                        class="examsc_a">PRACTICAL DATE SHEET OF CALENDER BATCH 2021</a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/PRACTICAL%20DATE%20SHEET%20OF%20CALENDAR%20BATCH%202022.pdf"
                        class="examsc_a">PRACTICAL DATE SHEET OF CALENDER BATCH 2022</a></p>
                    <h4 style="background: #29176d;color: white;padding: 21px; margin-bottom:15px">Date Sheet of
                        Acadamic Batch</h4>
                    <h4 style="background: #2d3e50;color: white;padding: 11px; margin-bottom:10px">Examination
                        Schedule</h4>

                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/MAIN%20EXAMINATION%20FIFTH%20SEMESTOR%20DATE%20SHEET%20OF%20CALENDAR-2020.pdf">MAIN
                        EXAMINATION FIFTH SEMESTER DATE SHEET OF CALENDER-2020</a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/MAIN EXAMINATION FIRST SEMESTOR DATE SHEET OF CALENDAR-2022.pdf"
                        class="examsc_a">MAIN EXAMINATION FIRST SEMESTER DATE SHEET OF CALENDER-2022
                    </a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/MAIN%20EXAMINATION%20FOURTH%20SEMESTOR%20DATE%20SHEET%20OF%20ACADEMIC-2020-21.pdf"
                        class="examsc_a">MAIN EXAMINATION FOURTH SEMESTER DATE SHEET OF ACADEMIC-2020-21</a></p>
                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/MAIN EXAMINATION SECOND SEMESTOR DATE SHEET OF ACADEMIC-2021-22 (1).pdf"
                        class="examsc_a">MAIN EXAMINATION SECOND SEMESTER DATE SHEET OF ACADEMIC-2021-22</a></p>

                    <p><a
                        target="_blank"
                        href="assets/documents/date-sheet/Aug2022/MAIN%20EXAMINATION%20THIRD%20SEMESTOR%20DATE%20SHEET%20OF%20CALENDAR-2021.pdf"
                        class="examsc_a">MAIN EXAMINATION THIRD SEMESTER DATE SHEET OF CALENDER-2021</a></p>
                    <p></p>
                </div>
            </div>
        </div>
    </div>
</div>
